import ConfirmResult from './ConfirmResult'

export default ConfirmResult
